import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

interface ContactFormData {
  title: string;
  fullNameLabel: string;
  emailLabel: string;
  messageLabel: string;
  submitButtonText: string;
  successMessage: string;
  errorMessage: string;
}

interface UseContactFormReturn {
  data: ContactFormData | null;
  loading: boolean;
  error: string | null;
}

export function useContactForm(): UseContactFormReturn {
  const [data, setData] = useState<ContactFormData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContactForm = async () => {
      try {
        setLoading(true);
        setError(null);
        const result: any = await apiService.getContactForm();
        const attributes = result?.attributes ? result.attributes : result;
        if (attributes) setData(attributes);
      } catch (err) {
        console.log('Contact form API not available yet, using fallback data');
        setError(null); // Don't set error, just use fallback data
      } finally {
        setLoading(false);
      }
    };

    fetchContactForm();
  }, []);

  return { data, loading, error };
} 